<template>
  <div class="container-fluid">
    <div class="loodsopname">
      <portlet
          :title="$t('shopfloor.loodsopname.currentScan')"
          class="mb-3"
      >
        <template slot="portletBody">
          <template v-if="!lastResponse">
            <p>{{ $t('shopfloor.loodsopname.nothingScanned') }}
            <div style="text-align: center; animation: blink 5s infinite; font-size: 8rem;"><span
                class="far fa-barcode-read"></span></div>
            <p class="scan-instruction">{{ $t('shopfloor.loodsopname.scanProduct') }}</p>
            <div class="manual-barcode-input-bottom barcode-input">
              <form @submit.prevent="barcodeScanned(manualBarcode)">
                <label for="manual-barcode">{{ $t('shopfloor.loodsopname.manualBarcode') }}</label>
                <div class="d-flex">
                  <input type="text" id="manual-barcode" class="form-control" v-model="manualBarcode"/>
                  <button class="btn btn-primary" type="submit">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
              </form>
            </div>
          </template>
          <template v-if="lastResponse && lastResponse.message !== 'BARCODE_NOT_FOUND'">
            <div class="loodsopname-text"><span>{{ lastResponse.product.name }}</span>
              <span>({{ lastResponse.product.productNumber }})</span>
            </div>
            <template v-if="lastResponse.outgoingCargo">
              <div class="loodsopname-text"><span>{{ $t('shopfloor.loodsopname.amountLoaded') }}:</span><span>{{
                  lastResponse.amountLoaded
                }} /
                {{ lastResponse.amountToLoadIncludingDeviations }}</span>
              </div>
            </template>
            <template v-if="lastResponse.deviations && lastResponse.deviations.length ">
              <div class="loodsopname-text"><span>{{ $t('shopfloor.loodsopname.deviations') }}:</span>
                <ul>
                  <li v-bind:key="deviation.type" v-for="deviation in getGroupedDeviations(lastResponse.deviations)">
                    {{ $t('shopfloor.loodsopname.deviation.' + deviation.type) }} ({{ deviation.amountSum }})
                  </li>
                </ul>
              </div>
            </template>
            <template v-else>
              <div class="loodsopname-text"><span>{{ $t('shopfloor.loodsopname.deviations') }}:</span> <span
                  class="no-data">{{ $t('shopfloor.loodsopname.noDeviations') }}</span></div>
            </template>
            <template v-if="lastResponse.outgoingCargo">
              <div class="loodsopname-text"><span>{{
                  $t('shopfloor.loodsopname.outgoingCargo')
                }}:</span><span>{{ lastResponse.outgoingCargo.reference }}
                  ({{ etdDateToString(lastResponse.outgoingCargo.estimatedTimeOfDeparture) }})</span>
              </div>
            </template>
            <template v-else>
              <div class="loodsopname-text"><span>{{
                  $t('shopfloor.loodsopname.outgoingCargo')
                }}:</span><span>{{ $t('shopfloor.loodsopname.noOutgoingCargo') }} </span></div>
            </template>
            <div class="loodsopname-text"><span v-if="lastResponse.locations && lastResponse.locations.length">{{
                $t('shopfloor.loodsopname.locations')
              }}:</span> <span
                v-if="!lastResponse.locations || !lastResponse.locations.length"
                class="not-unloaded">{{ $t('shopfloor.loodsopname.noLocations') }}</span></div>
            <template v-if="lastResponse.locations && lastResponse.locations.length">
              <div class="loodsopname-text">
                <ul>
                  <li v-bind:key="location.id" v-for="location in lastResponse.locations">{{ location.name }}
                    ({{ location.stock }})
                  </li>
                </ul>
              </div>
            </template>
            <template v-if="1 > 0 || lastResponse.message === 'NO_OUTGOING_PLANNED'">
              <div>
                <div class="product-is-ok">
                  <i class="fas fa-check"></i>
                </div>
              </div>
            </template>
            <div>
              <button class="next-product-button btn btn-primary" @click="nextProduct()">
                {{ $t('shopfloor.loodsopname.nextProduct') }}
              </button>
            </div>
          </template>
        </template>
      </portlet>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'loodsopname',
  components: {},
  mixins: [],
  data() {
    return {
      checkingBarcode: '',
      manualBarcode: '',
      lastResponse: null
    };
  },
  computed: {
    ...mapGetters('users', [
      'getMeBasic'
    ])
  },
  methods: {
    etdDateToString(etdDate) {
      return moment(etdDate).format('DD/MM HH:mm');
    },
    showSomethingWentWrongToast() {
      this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'error',
        title: this.$t('shopfloor.loodsopname.requestFailed')
      });
    },
    showUnknownBarcodeToast() {
      this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'error',
        title: this.$t('shopfloor.loodsopname.unknownBarcode')
      });
    },
    showLoadThisProductToast() {
      this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        showConfirmButton: true,
        confirmButtonText: 'Ok',
        type: 'info',
        title: this.$t('shopfloor.loodsopname.loadThisProduct')
      });
    },
    showProductPresentOnFloorSendToast() {
      this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'success',
        title: this.$t('shopfloor.loodsopname.presentOnFloorSend')
      });
    },
    showNoDataToDeclareDeviationToToast() {
      this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'error',
        title: this.$t('shopfloor.loodsopname.noCargoFound')
      });
    },
    async declareProductPresentOnFloor() {
      // We create the full deviation here with the data we got from the http call
      // This either comes from the incoming order product OR a previous deviation created on this incoming order product
      if (this.lastResponse.incomingData) {
        let user = this.getMeBasic;
        const deviationData = {
          type: 'PRESENT_ON_FLOOR',
          userId: user.userId,
          userName: user.userName,
          companyId: user.companyId,
          location: this.lastResponse.incomingData.location,
          locationAdditional: this.lastResponse.product.productNumber,
          remark: '',
          amount: 1,
          orderId: this.lastResponse.incomingData.orderId,
          recordId: `${this.lastResponse.incomingData.incomingOrderProductId}`,
          pickLocationAtMomentOfRegistering: null,
          created_at: new Date(),
          cargoId: this.lastResponse.incomingData.cargoId,
          customer: this.lastResponse.incomingData.customer,
          deviationDataComplete: true,
          estimatedTime: new Date(this.lastResponse.incomingData.estimatedTime),
          packingListNumber: this.lastResponse.incomingData.packingListNumber,
          productName: this.lastResponse.incomingData.productName,
          receiver: this.lastResponse.incomingData.receiver,
          sentToTranspas: false,
          trailer: '',
          truck: '',
          cargoReference: this.lastResponse.incomingData.cargoReference
        };
        await this.$FB.collection('deviations').add(deviationData);
        this.showProductPresentOnFloorSendToast();
      } else if (this.lastResponse.outgoingCargo) {
        // Fallback voor als de inkomende vracht er niet meer is, nog nooit een loodsopname is gedaan
        // Maar de uitgaande vracht er wel nog steeds is.
        let user = this.getMeBasic;
        const deviationData = {
          type: 'PRESENT_ON_FLOOR',
          userId: user.userId,
          userName: user.userName,
          companyId: user.companyId,
          location: 'loading',
          locationAdditional: this.lastResponse.product.productNumber,
          remark: '',
          amount: 1,
          orderId: this.lastResponse.outgoingCargo.orderId,
          recordId: `${this.lastResponse.outgoingCargo.orderProductId}`,
          pickLocationAtMomentOfRegistering: null,
          created_at: new Date()
        };
        await this.$FB.collection('deviations').add(deviationData);
        this.showProductPresentOnFloorSendToast();
      } else {
        this.showNoDataToDeclareDeviationToToast();
      }
    },
    resetProgress() {
      this.manualBarcode = '';
      this.checkingBarcode = '';
      this.lastResponse = null;
    },
    nextProduct() {
      this.resetProgress();
    },
    getGroupedDeviations(deviations) {
      const groupedDeviationsArray = [];
      const groupedDeviations = _.groupBy(deviations, 'type');
      Object.keys(groupedDeviations).forEach(deviationType => {
        groupedDeviationsArray.push({
          type: deviationType,
          deviations: groupedDeviations[deviationType],
          amountSum: _.sumBy(groupedDeviations[deviationType], 'amount')
        });
      });
      return groupedDeviationsArray;
    },
    amountToLoadEqualsExceedsCargoLimits() {
      return this.lastResponse.amountToLoadIncludingDeviations - (this.lastResponse.amountLoaded + _.sumBy(_.filter(this.lastResponse.deviations, {type: 'exceeds_cargo_limits'}), 'amount')) <= 0
    },
    async showPlannedPopUp() {
      let modalhtml = '';
      modalhtml += `<div class="loodsopname-text">${this.lastResponse.product.name} (${this.lastResponse.product.productNumber})</div>`;
      if (this.lastResponse.outgoingCargo) {
        modalhtml += `<div class="loodsopname-text">${this.$t('shopfloor.loodsopname.amountLoaded')}: ${this.lastResponse.amountLoaded}/${this.lastResponse.amountToLoadIncludingDeviations}</div>`;
      }
      if (this.lastResponse.deviations && this.lastResponse.deviations.length) {
        modalhtml += `<div class="loodsopname-text">${this.$t('shopfloor.loodsopname.deviations')}:`;
        modalhtml += `<ul>`;
        this.getGroupedDeviations(this.lastResponse.deviations).forEach(deviation => {
          modalhtml += ('<li>' + this.$t('shopfloor.loodsopname.deviation.' + deviation.type) + ` (${deviation.amountSum}) </li>`);
        });
        modalhtml += `</ul></div>`;
      } else {
        modalhtml += `<div class="loodsopname-text"><span class="no-data">${this.$t('shopfloor.loodsopname.deviations')}: ${this.$t('shopfloor.loodsopname.noDeviations')}</span></div>`;
      }
      if (this.lastResponse.outgoingCargo) {
        modalhtml += `<div class="loodsopname-text">${this.$t('shopfloor.loodsopname.outgoingCargo')}: ${this.lastResponse.outgoingCargo.reference} (${this.etdDateToString(this.lastResponse.outgoingCargo.estimatedTimeOfDeparture)})</div>`;
      } else {
        modalhtml += `<div class="loodsopname-text"><span class="no-data">${this.$t('shopfloor.loodsopname.outgoingCargo')}: ${this.$t('shopfloor.loodsopname.noOutgoingCargo')}  </span></div>`;
      }
      if (this.lastResponse.locations && this.lastResponse.locations.length) {
        modalhtml += `<div class="loodsopname-text">${this.$t('shopfloor.loodsopname.locations')}:`;
        modalhtml += `<ul>`;
        this.lastResponse.locations.forEach(location => {
          modalhtml += (`<li> ${location.name} (${location.stock})</li>`);
        });
        modalhtml += `</ul></div>`;
      } else {
        modalhtml += `<div class="loodsopname-text"><span class="not-unloaded">${this.$t('shopfloor.loodsopname.noLocations')}</span></div>`;
      }
      modalhtml += `<div class="loodsopname-text"><b>${this.$t('shopfloor.loodsopname.checkCargoStillHere')}</b></div>`;

      return this.$swal({
        title: this.$root.$t('shopfloor.loodsopname.checkCargo'),
        html: modalhtml,
        showCancelButton: true,
        showConfirmButton: true,
        reverseButtons: true,
        cancelButtonText: this.$root.$t('shopfloor.loodsopname.cargoNotPresent'),
        confirmButtonText: this.$root.$t('shopfloor.loodsopname.cargoPresent')
      });
    },
    async barcodeScanned(barcode) {
      if (!this.lastResponse) {
        this.$store.commit('setLoading', true);
        this.lastResponse = await this.checkBarcode(barcode);
        this.$store.commit('setLoading', false);
        if (!this.lastResponse) {
          this.showSomethingWentWrongToast();
        } else if (this.lastResponse.message === 'OUTGOING_PLANNED') {
          if (this.amountToLoadEqualsExceedsCargoLimits()) {
            await this.declareProductPresentOnFloor();
          } else {
            const dialogResult = await this.showPlannedPopUp();
            if (dialogResult.value) {
              this.showLoadThisProductToast();
            } else {
              await this.declareProductPresentOnFloor();
            }
          }
        } else if (this.lastResponse.message === 'BARCODE_NOT_FOUND') {
          this.showUnknownBarcodeToast();
          this.lastResponse = null;
        } else if (this.lastResponse.message === 'NO_OUTGOING_PLANNED') {
          console.log("No planned");
          await this.declareProductPresentOnFloor();
        } else {
          console.log("this.lastResponse.message", this.lastResponse.message)
        }
      }
    },
    async checkBarcode(barcode) {
      try {
        const res = await this.$CLOUD_API.get(`/loodsopname/${barcode}`);
        return res.data;
      } catch (e) {
        console.error(e);
        return null;
      }
    }
  },
  watch: {},
  async beforeRouteLeave(from, to, next) {
    this.resetProgress();
    await this.$barcodeScanner.barCodeEventBus.$off('barcodeScanned', this.barcodeScanned);
    next();
  },
  created() {
    this.$barcodeScanner.barCodeEventBus.$on('barcodeScanned', this.barcodeScanned);
  }
};
</script>


<style lang="scss">
ul {
  margin-bottom: 0px;
}

.loodsopname-text {
  margin-bottom: 1rem;
}

.loodsopname {
  margin-top: 15px;
}

.loodsopname > .m-portlet > .m-portlet__head > .m-portlet__head-caption > .m-portlet__head-title > .m-portlet__head-text {
  color: #00c9ff !important;
}

.scan-instruction {
  font-weight: bold;
  text-align: center;
}

.product-is-ok {
  color: #42dd00;
  text-align: center;
  font-size: 7rem;
}

.next-product-button {
  width: 100%;
}

</style>

<style>
.not-unloaded {
  color: red;
}

</style>


